// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { IRequestPesquisaCita, ConsultaDocumentos, Types } from './types';

export function consultaDocumentosRequest(
	token: string,
	payload: IRequestPesquisaCita,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTA_DOCUMENTOS_REQUEST,
		token,
		payload,
	};
}

export function consultaDocumentosSuccess(
	payload: ConsultaDocumentos,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTA_DOCUMENTOS_SUCCESS,
		payload,
	};
}

export function consultaDocumentosFailure(): ReducerActionRotaSP {
	return {
		type: Types.CONSULTA_DOCUMENTOS_FAILURE,
		payload: null,
	};
}

export function limpaconsultaDocumentos(): ReducerActionRotaSP {
	return {
		type: Types.LIMPA_CONSULTA_DOCUMENTOS,
		payload: null,
	};
}
